<div class="splash-root-container">

    <div class="logo-container">
        <img src="assets/images/logos/sp_logo.svg">
    </div>
</div>